import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { apiClient } from "../../config/api";
import Loader from "../../common/Loader";
import SectionDivider from "../../common/SectionDivider";
import { ColorArray } from "../../config/ColorArray";
import { imageUrl } from "../../utils/imageUrl";
import "./NavUjaniye.css";

const NavUjaniyeMaterial = () => {
  const { id } = useParams();
  const location = useLocation();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const pageTitle = useMemo(() => {
    return (
      location?.state?.title ||
      location?.state?.name ||
      location?.state?.label ||
      "ચાલો નવું જાણીએ"
    );
  }, [location]);

  useEffect(() => {
    const fetchMaterial = async () => {
      try {
        setLoading(true);
        setError(null);

        const listId = encodeURIComponent(String(id || ""));
        const endpoints = [
          `/navu_janiye_material?selectedNavuJaniyeListId=${listId}`,
          `/navu-janiye-material?selectedNavuJaniyeListId=${listId}`,
          `/navu_janiye_material?navuJaniyeListId=${listId}`,
          `/navu_janiye_material?navu_janiye_list_id=${listId}`,
          `/navu_janiye_material/${listId}`,
          `/navu-janiye-material/${listId}`,
        ];

        let lastErr = null;
        for (const endpoint of endpoints) {
          try {
            const res = await apiClient.get(endpoint);

            let material = [];
            if (Array.isArray(res.data)) {
              material = res.data;
            } else if (res.data?.data && Array.isArray(res.data.data)) {
              material = res.data.data;
            } else if (res.data?.result && Array.isArray(res.data.result)) {
              material = res.data.result;
            } else {
              const values = Object.values(res.data || {});
              const arr = values.find((v) => Array.isArray(v));
              if (arr) material = arr;
            }

            if (material.length > 0) {
              setData(material);
              return;
            }
          } catch (e) {
            lastErr = e;
          }
        }

        if (lastErr) {
          setError(lastErr?.message || "Failed to fetch data");
        }
        setData([]);
      } catch (e) {
        setError(e?.message || "Failed to fetch data");
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMaterial();
  }, [id]);

  if (loading) {
    return (
      <div className="nav-ujaniye-container">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="nav-ujaniye-container">
        <div className="nav-ujaniye-error">
          <h2>Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <SectionDivider title={pageTitle} />
      <div className="nav-ujaniye-container">
        {data.length === 0 ? (
          <div className="nav-ujaniye-empty">
            <p>No data found at the moment.</p>
          </div>
        ) : (
          <div className="nav-ujaniye-grid">
            {data.map((item, index) => {
              const rawImage =
                item.navu_janiye_material_image ||
                item.material_image ||
                item.image ||
                item.img ||
                "";

              const finalImage = rawImage ? imageUrl(rawImage) : null;

              const titleGuj =
                item.navu_janiye_material_title_gujarati ||
                item.title_gujarati ||
                item.title ||
                item.name ||
                "";

              const titleEng =
                item.navu_janiye_material_title_english ||
                item.title_english ||
                "";

              const titleHin =
                item.navu_janiye_material_title_hindi ||
                item.title_hindi ||
                "";

              return (
                <div
                  key={item.id || item._id || index}
                  className="nav-ujaniye-card"
                  style={{
                    background: `linear-gradient(135deg, ${ColorArray[index % ColorArray.length].color1} 0%, ${ColorArray[index % ColorArray.length].color2} 100%)`,
                  }}
                >
                  <div className="nav-ujaniye-card-content">
                    <div className="nav-ujaniye-card-image-wrapper">
                      {finalImage ? (
                        <img
                          src={finalImage}
                          alt={titleGuj || titleEng || titleHin || "Material"}
                          className="nav-ujaniye-card-image"
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <div className="nav-ujaniye-card-image-placeholder">Material</div>
                      )}
                    </div>

                    <div className="nav-ujaniye-card-titles">
                      {titleGuj ? (
                        <h3 className="nav-ujaniye-card-title nav-ujaniye-title-gujarati">
                          {titleGuj}
                        </h3>
                      ) : null}

                      {titleEng ? (
                        <h4 className="nav-ujaniye-card-subtitle nav-ujaniye-title-english">
                          {titleEng}
                        </h4>
                      ) : null}

                      {titleHin ? (
                        <h4 className="nav-ujaniye-card-subtitle nav-ujaniye-title-hindi">
                          {titleHin}
                        </h4>
                      ) : null}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default NavUjaniyeMaterial;
